// Helpers for DftAsyncPanel (AppShell.jsx): the Stop request and the
// running-job progress line.
import { capabilityDeniedMessage } from './capabilityErrors';

// Bug #85 (2026-11-05): Stop used to swallow every failure and reset the
// panel anyway, so a job whose cancel never reached the service showed as
// stopped while it kept running. This resolves to { status } only when the
// service confirmed ('cancelling' or a terminal status it already had), and
// to { error } for a network failure, an HTTP error or a refusal.
export async function requestDftStop(fetchFn, url, options = {}) {
  let r;
  try {
    r = await fetchFn(url, { method: 'POST', ...options });
  } catch (e) {
    return { error: `Could not reach the service: ${e?.message || e}` };
  }
  let body = null;
  try {
    body = await r.json();
  } catch (_) { /* no JSON body */ }
  if (!r.ok || !body || body.ok === false) {
    const msg = capabilityDeniedMessage(body)
      || (typeof body?.error === 'string' && body.error)
      || (typeof body?.detail === 'string' && body.detail)
      || `Stop request failed (HTTP ${r.status}).`;
    return { error: msg };
  }
  return { status: body.status || 'cancelling' };
}

// One line describing a running job's progress, or null when there is
// nothing to show. Elastic tensor reports deformations; relax (bug #89)
// reports the BFGS step and max force against the target.
export function dftProgressText(kind, progress) {
  if (!progress) return null;
  if (kind === 'dft_elastic_tensor' && progress.total != null) {
    return `Deformation ${progress.done} of ${progress.total}.`;
  }
  if (kind === 'dft_relax' && progress.step != null && progress.fmax != null) {
    return `Step ${progress.step}: max force ${Number(progress.fmax).toFixed(3)} eV/Å (target ${progress.target_fmax}).`;
  }
  return null;
}
